"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Collapse = void 0;
var react_1 = __importStar(require("react"));
exports.Collapse = function (_a) {
    var children = _a.children, _b = _a.closed, closed = _b === void 0 ? false : _b, id = _a.id;
    var _c = react_1.useState(!(closed || false)), stateOpen = _c[0], setOpen = _c[1];
    react_1.useEffect(function () {
        var timer = setTimeout(function () {
            setOpen(!closed);
        }, 200); // timer should match animation length in css
        return function () {
            clearTimeout(timer);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [closed]);
    var cssClass = [
        'o-collapse',
        closed && 'o-collapse--hide',
        !closed && stateOpen && 'o-collapse--open',
        !closed && !stateOpen && 'o-collapse--show'
    ]
        .filter(Boolean)
        .join(' ');
    return (react_1.default.createElement("div", { id: id, className: cssClass },
        react_1.default.createElement("div", { className: "o-collapse__inner" }, children)));
};
exports.default = exports.Collapse;
